import { faSortAlphaDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Switch, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { action, computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';

const KeyframesBlinkBotaoOrdenar = styled('span')({
    '@keyframes blink': {
        from: {
            opacity: 1
        },
        to: {
            opacity: 0.3
        }
    },
    animation: 'blink 1s',
    animationIterationCount: 'infinite'
});

class OrdenacaoProcessos extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            ordenarProcessos: action,
            handleChange: action,
            corIconeOrdenacao: computed,
            tooltipIconeOrdenacao: computed,
            tooltipSwitchOrdenacaoAutomatica: computed
        });
    }

    ordenarProcessos() {
        if (this.sessaoStore.sessaoSelecionada) {
            this.sessaoStore.botaoOrdenacaoAcionado = true;

            if (this.sessaoStore.mensagemOrdenacaoPendente) {
                this.sessaoStore.ordenarProcessosEnvelope(this.sessaoStore.mensagemOrdenacaoPendente);
            } else {
                this.salaSessaoStore.ordenarProcessos();
            }
        } else {
            this.mensagemStore.abrirMensagemInfo(
                'Não há sessão selecionada ou não existem processos na sessão selecionada.'
            );
        }
    }

    handleChange() {
        this.sessaoStore.ordenacaoProcessosHabilitada = !this.sessaoStore.ordenacaoProcessosHabilitada;

        if (this.sessaoStore.ordenacaoProcessosHabilitada && this.sessaoStore.mensagemOrdenacaoPendente) {
            this.ordenarProcessos();
        }
    }

    get corIconeOrdenacao() {
        if (this.sessaoStore.mensagemOrdenacaoPendente) {
            return 'darkorange';
        }

        return this.sessaoStore.ordenacaoProcessosHabilitada ? 'black' : 'gray';
    }

    get tooltipIconeOrdenacao() {
        return this.sessaoStore.mensagemOrdenacaoPendente
            ? 'Ordenar processos - Atenção: há reordenação pendente'
            : 'Ordenar processos';
    }

    get renderBotao() {
        return (
            <FontAwesomeIcon
                icon={faSortAlphaDown}
                onClick={this.ordenarProcessos.bind(this)}
                color={this.corIconeOrdenacao}
                style={{ cursor: 'pointer', width: '22px', height: '22px' }}
            />
        );
    }

    get tooltipSwitchOrdenacaoAutomatica() {
        let msg = this.sessaoStore.ordenacaoProcessosHabilitada ? 'Desabilitar' : 'Habilitar';
        msg += ' ordenação automática dos processos';

        return msg;
    }

    render() {
        return (
            <>
                <Tooltip
                    title={this.tooltipSwitchOrdenacaoAutomatica}
                    placement="top-start"
                >
                    <Switch
                        checked={this.sessaoStore.ordenacaoProcessosHabilitada}
                        onChange={this.handleChange.bind(this)}
                    />
                </Tooltip>
                <Tooltip
                    title={this.tooltipIconeOrdenacao}
                    placement="top-start"
                >
                    <div className="corBotao">
                        {this.sessaoStore.mensagemOrdenacaoPendente ? (
                            <KeyframesBlinkBotaoOrdenar>{this.renderBotao}</KeyframesBlinkBotaoOrdenar>
                        ) : (
                            this.renderBotao
                        )}
                    </div>
                </Tooltip>
            </>
        );
    }
}

export default inject('stores')(observer(OrdenacaoProcessos));
